
$(function () {
    var loader = $('.news-loading');
    var viewMoreBtn = $('.view-more-news-btn');

    loader.hide();
    viewMoreBtn.hide();

    // when the page loads and it's got the news widget, get the first X items
    $(document).ready(function () {
        // force the list to load on initial page load.
        var newsObj = $('.news-article-list');
        var newsObjAlt = $('.news-article-list-alt');
        if (newsObj.length > 0) {

            var pageNum = 1;
            let searchParams = new URLSearchParams(window.location.search)
            if (searchParams.has('page')) {
                var sNum = parseInt(searchParams.get('page'));

                if (!isNaN(sNum)) {
                    pageNum = sNum
                }
            }

            if (pageNum > 1) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#article-listing-anchor").offset().top
                }, 500);
            }

            GetPagedData(pageNum, `${newsObj.data('pager-type')}`, `${newsObj.data('pager-path')}`, `${newsObj.data('pager-topn')}`, `${newsObj.data('pager-investurl')}`, false, 11);
        }
        if (newsObjAlt.length > 0) {

            var pageNum = 1;
            let searchParams = new URLSearchParams(window.location.search)
            if (searchParams.has('page')) {
                var sNum = parseInt(searchParams.get('page'));

                if (!isNaN(sNum)) {
                    pageNum = sNum
                }
            }

            if (pageNum > 1) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#article-listing-anchor").offset().top
                }, 500);
            }

            GetPagedData(pageNum, `${newsObjAlt.data('pager-type')}`, `${newsObjAlt.data('pager-path')}`, `${newsObjAlt.data('pager-topn')}`, '', true);
        }
    });

    // trigger once pager numbers are clicked.
    $('#news-article-list-pagination').on('click', '.page-item', function (e) {
        e.preventDefault();
        var itemObj = $(e.target);
        if (itemObj) {
            // update the history and the url so people can go back to that given page.
            var pageNum = parseInt(itemObj.data('pager-page'));

            if (!pageNum || isNaN(pageNum)) {
                itemObj = itemObj.parent();
                pageNum = parseInt(itemObj.data('pager-page'));
            }
            var newUrl = update_query_parameters('page', pageNum);
            window.location.href = newUrl;
        }
    });
});


function update_query_parameters(key, val) {
    uri = window.location.href
        .replace(RegExp("([?&]" + key + "(?=[=&#]|$)[^#&]*|(?=#|$))"), "&" + key + "=" + encodeURIComponent(val))
        .replace(/^([^?&]+)&/, "$1?");
    return uri;
}

function GetPagedData(pageNum, type, path, topN, investUrl, isAltLayout, numItemsPerPage = 9) {
    var loader = $('.news-loading');
    var viewMoreBtn = $('.view-more-news-btn');
    var displayStocks = $('.display-stocks').val();

    loader.show();

    $.ajax({
        url: '/News/GetPagedData',
        method: 'GET',
        data: {
            'type': type,
            'path': path,
            'topN': topN,
            'pageNumber': pageNum,
            'pageSize': numItemsPerPage,
            displayStocks
        },
        success: function (resp) {

            var rowData = "";
            var delay = 0;
            for (var i = 0; i < resp.data.length; i++) {

                if (i > 0) {
                    var amt = $('.ze-news-list').data('anim-delay-increment');
                    delay += parseInt(amt);
                }

                if (i % 3 == 0) {
                    delay = 0;
                }

                if (isAltLayout) {
                    rowData += NewsArticleListingTemplateAlt(resp.data[i], delay);
                } else {
                    rowData += NewsArticleListingTemplate(resp.data[i], investUrl, delay);
                }
            }

            if (isAltLayout) {
                $(".news-article-list-alt").html("");
                $(".news-article-list-alt").append(rowData);
            } else {
                //$(".news-article-list").html("");
                $(".news-article-list").append(rowData);
            }

            $("#news-article-list-pagination").html("");

            if (resp.totalPages > 1) {
                var pagerTemplate = PagingTemplate(resp.totalPages, resp.currentPage, type, path, topN, investUrl);
                $("#news-article-list-pagination").append(pagerTemplate);

                if (pageNum > 1) {
                    $(".stock-ticker").hide();
                } else {
                    $(".stock-ticker").show();
                }
            }

            loader.hide();
            if (viewMoreBtn && topN > 0) {
                viewMoreBtn.show();
            }
        },
        error: function (xhr, status, error) {
            // errored out
        }
    });

    //$.getJSON("/News/GetPagedData", { type: type, path: path, topN: topN, pageNumber: pageNum, pageSize: 9, displayStocks }, function (response) {

    //});
}

function NewsArticleListingTemplate(data, investorURL, delay) {
    var template = "";

    template += `<div class="ze-news-item col-12 col-md-6 col-xl-4 g-md-4" data-aos="${$('.ze-news-list').data('anim')}" data-aos-duration="${$('.ze-news-list').data('anim-duration')}" data-aos-delay="${delay}"><div class="ze-news-item__inner bg-white h-100">`;

    template += `<div class="ze-news-item__cat">${data.newsFormattedDate}</div>`;
    template += `<div class="ze-news-item__title">${data.newsTitle}</div>`;
    /*template += `<p>${data.newsTeaserText}</p>`;*/
    template += `<div class='ze-news-item__links'><a href="${data.newsUrl}" target="${data.newsUrl.includes(investorURL) ? "_blank" : ""}"><span>Read more </span> ></a>`;

    if (data.downloadUrl != null && data.downloadUrl != "") {
        template += `<a class="news-article-download" href="${data.downloadUrl}" target="_blank"><span>Download </span> <i class='fa fa-download'></i></a>`;
    }

    template += '</div></div></div>';

    return template;
}

function NewsArticleListingTemplateAlt(data, delay) {
    var template = "";

    template += `<div class="ze-news-item-alt g-md-4" data-aos="${$('.ze-news-list').data('anim')}" data-aos-duration="${$('.ze-news-list').data('anim-duration')}"  data-aos-delay="${delay}"><div class="ze-news-item__inner h-100 bg-white">`;

    template += `<div class="ze-news-item__cat">${data.newsFormattedDate}</div>`;
    template += `<div class="ze-news-item__title">${data.newsTitle}</div>`;
    /*template += `<p>${data.newsTeaserText}</p>`;*/
    template += `<div class='ze-news-item__links'><a href="${data.newsUrl}" target="_blank"><span>Read more </span> ></a>`;

    if (data.downloadUrl != null && data.downloadUrl != "") {
        template += `<a class="news-article-download" href="${data.downloadUrl}" target="_blank"><span>Download </span> <i class='fa fa-download'></i></a>`;
    }

    template += '</div></div></div>';

    return template;
}